import {
  LOAD_COMP,
  LOAD_DIVISION,
  LOAD_DEPARTMENT,
  LOAD_SECTION,
  LOAD_PLANT,
  LOAD_DATA_DASHBOARD,
  LOAD_LOCATIONS_NEARBY_PLANT,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  loading_comp: false,
  data_comp: [],

  loading_division: false,
  data_division: [],

  loading_department: false,
  data_department: [],

  loading_section: false,
  data_section: [],

  loading_plant: false,
  data_plant: [],

  loading_data_dashboard: false,
  data_dashboard: [],

  loading_locations_nearby_plant: false,
  locations_nearby_plant: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case LOAD_COMP.REQUEST:
      return {
        ...state,
        loading_comp: false,
        data_comp: [],
        data_division: [],
        data_department: [],
        data_section: [],
        data_plant: [],
      }

    case LOAD_COMP.SUCCESS:
      return {
        ...state,
        loading_comp: true,
        data_comp: action.payload.lists,
      }

    case LOAD_DIVISION.REQUEST:
      return {
        ...state,
        loading_division: false,
        data_division: [],
        data_department: [],
        data_section: [],
        data_plant: [],
      }

    case LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        loading_division: true,
        data_division: action.payload.lists,
      }

    case LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        loading_department: false,
        data_department: [],
        data_section: [],
        data_plant: [],
      }

    case LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        loading_department: true,
        data_department: action.payload.lists,
      }

    case LOAD_SECTION.REQUEST:
      return {
        ...state,
        loading_section: false,
        data_section: [],
        data_plant: [],
      }

    case LOAD_SECTION.SUCCESS:
      return {
        ...state,
        loading_section: true,
        data_section: action.payload.lists,
      }

    case LOAD_PLANT.REQUEST:
      return {
        ...state,
        loading_plant: false,
        data_plant: [],
      }

    case LOAD_PLANT.SUCCESS:
      return {
        ...state,
        loading_plant: true,
        data_plant: action.payload.lists,
      }

    case LOAD_DATA_DASHBOARD.REQUEST:
      return {
        ...state,
        loading_data_dashboard: false,
        data_dashboard: [],
      }

    case LOAD_DATA_DASHBOARD.SUCCESS:
      return {
        ...state,
        loading_data_dashboard: true,
        data_dashboard: action.payload.lists,
      }

    case LOAD_LOCATIONS_NEARBY_PLANT.REQUEST:
      return {
        ...state,
        loading_locations_nearby_plant: false,
        locations_nearby_plant: [],
      }

    case LOAD_LOCATIONS_NEARBY_PLANT.SUCCESS:
      return {
        ...state,
        loading_locations_nearby_plant: true,
        locations_nearby_plant: action.payload.lists,
      }
    default:
      return state
  }
}
